import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiClient from "../api/apiClient";
import { RootState } from "./store";

interface PaymentState {
  loading: boolean;
  user: any | null;
  error: string | null;
  isLoggedIn: boolean;
  clientSecret: string | null;
}

const initialState: PaymentState = {
  loading: false,
  user: null,
  error: null,
  isLoggedIn: false,
  clientSecret: null,
};

export const createPaymentIntent = createAsyncThunk(
  "payments/createPaymentIntent",
  async (programId: any, thunkAPI) => {
    try {
      const response = await apiClient.post('/api/v1/payment/book-now', {
        programId: programId,
      });
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(`Fetch failed: ${error.message}`);
    }
  }
);

export const createPaymentFree = createAsyncThunk(
  "payments/createPaymentFree",
  async (programId: any, thunkAPI) => {
    try {
      const targetId = typeof programId === 'object' && programId !== null ? programId.programId : programId;
      const response = await apiClient.post('/api/v1/patients/userBookingDetails/book-free', {
        programId: targetId,
      });
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(`Fetch failed: ${error.message}`);
    }
  }
);

// ./store/paymentSlice.ts
export const selectClientSecret = (state: RootState) => state.payments.clientSecret;

const paymentSlice = createSlice({
  name: "payments",
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPaymentIntent.pending, (state) => {
        state.loading = true;
        state.error = null; // Reset error on pending
      })
      .addCase(createPaymentIntent.fulfilled, (state, action) => {
        state.loading = false;
        // Update based on your API response structure
        state.clientSecret = action.payload.data.clientSecret; // Check the correct path
      })
      .addCase(createPaymentIntent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        console.error("Error creating payment intent:", action.payload); // Log the detailed error
      })
      .addCase(createPaymentFree.pending, (state) => {
        state.loading = true;
        state.error = null; // Reset error on pending
      })
      .addCase(createPaymentFree.fulfilled, (state, action) => {
        state.loading = false;
        // Update based on your API response structure
        state.clientSecret = action.payload.data; // Check the correct path
      })
      .addCase(createPaymentFree.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        console.error("Error creating payment intent:", action.payload); // Log the detailed error
      });
      
  },
});
  
export const { resetState } = paymentSlice.actions;
export default paymentSlice.reducer;
